import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClose"];
import { Drawer } from '@mui/material';
import { useEffect, useState } from 'react';
var AwaitedDrawer = function (_ref) {
    var children = _ref.children, onClose = _ref.onClose, others = _objectWithoutProperties(_ref, _excluded);
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    useEffect(function () {
        setOpen(true);
    }, []);
    return /*#__PURE__*/ React.createElement(Drawer, _extends({}, others, {
        open: open,
        onClose: function (e, reason) {
            setOpen(false);
            onClose === null || onClose === void 0 || onClose(e, reason);
        }
    }), children);
};
export default AwaitedDrawer;
